"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPONENT_KEY = {
  Flexy: 'Flexy',
  Block: 'Flexy.Block',
  Item: 'Flexy.Item'
};